import { GenericService } from './Generic.service';


export class RelationShipService extends GenericService<string>{
    
    readonly URI: string = "PostoTrabalho"

    constructor(){
        super();
        this.setUri(this.URI);
    }


    public async FetchRelationShipAll(company: string){
        return await super.getByResource(company)
    }

    public async getRelationShipGhe(companyId: string){
        return await super.getByResource(`${companyId}/PostoTrabalhoSaudeOcupacional`);
    }

    public async updateRelationshipPost(companyId: string, body: any){
        return await super.postByResource(body, `${companyId}/PostoTrabalhoSaudeOcupacional`);
    }

    public async updateRelationshipPut(companyId: string, idRelation: string, body: any){
        return await super.putByResource(body, `${companyId}/PostoTrabalhoSaudeOcupacional/${idRelation}`);
    }
    



}